/**
 * Performs a Luhn (mod 10) checksum check on a payment card number
 * and returns true if the number is valid, false otherwise.
 */
export function passesLuhnCheck(digits: string): boolean {
    // Remove non-digit characters
    const sanitized = digits.replace(/\D/g, '');

    if (sanitized.length === 0) {
        return false;
    }

    let sum = 0;

    // This flag determines whether to double the current digit
    // It alternates as we move from right to left
    let alternate = false;

    // Iterate over the digits from right to left
    for (let i = sanitized.length - 1; i >= 0; i--) {
        const char = sanitized[i];
        let digit = parseInt(char, 10);

        if (alternate) {
            digit *= 2;

            // If the doubled value is greater than 9, subtract 9
            if (digit > 9) {
                digit -= 9;
            }
        }

        sum += digit;
        alternate = !alternate;
    }

    // A valid Luhn number will have a total sum divisible by 10
    return sum % 10 === 0;
}
